import { CLEAR_SEARCH, SET_FACET_TEXT, TOGGLE_SHOW_SELECTED } from './DataCutsActions';

const initialState = {
  isSelected: true,
  searchText: ''
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_SEARCH:
      return {
        ...state,
        searchText: '',
        isSelected: true
      };
    case SET_FACET_TEXT:
      return {
        ...state,
        searchText: action.data
      };

    case TOGGLE_SHOW_SELECTED:
      return {
        ...state,
        isSelected: !state.isSelected
      };
    default:
      return { ...state };
  }
}

export const dataCutsActions = {};
